export default __webpack_public_path__ + "static/media/bomberDodger.8cbb4e7f.png";